import React, { useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import AccessibilityToggle from '../AccessibilityToggle/AccessibilityToggle';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="layout">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
      <div className="layout-main">
        {/* Mobile hamburger button */}
        <button
          className="mobile-menu-button"
          onClick={toggleSidebar}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className="layout-content" id="main-content">{children}</div>
      </div>
      <AccessibilityToggle />
    </div>
  );
};

export default Layout;
